import { useTailgateGrid } from '../hooks/useTailgateGrid'

import { Box, Center, Image, Skeleton, Text } from '@chakra-ui/react'

import {
  IMAGE_HEIGHT,
  IMAGE_WIDTH,
  calculateAspectRatioFit,
} from '../utils/utils'
import { TailgateGrid } from './TailgateGrid'

interface GridCameraFrameIProps {
  isImageLoading: boolean
  imageUrl?: string
}

export const GridCameraFrame = ({
  imageUrl,
  isImageLoading,
}: GridCameraFrameIProps) => {
  const { videoDimensions } = useTailgateGrid()

  const { width, height } = calculateAspectRatioFit(
    videoDimensions?.width,
    videoDimensions?.height,
    IMAGE_WIDTH,
    IMAGE_HEIGHT
  )

  if (isImageLoading) {
    return (
      <Skeleton
        borderRadius='0.375rem'
        data-testid='tailgateGridModal_cameraFrame_skeleton'
        h='524px'
        maxW='100%'
        minW='577px'
      />
    )
  }

  /**
   * This feels kinda hacky, but what we have here is a series of 3 Boxes:
   *  - One main external box to ensure that the size of the preview doesn't ever change
   *  - One inner box that adjusts size based on above call to calculateAspectRatioFit
   *    - This is required to ensure that video and TailgateGrid are exact same size and scale together as
   *      technically the tailgate grid is just rendered on top of the image, and if either of them changes sizes
   *      without the other matching exactly it will result in a discrepancy in boxes.
   *
   *  See comment with more context & visual aids: https://github.com/hivewatch/frontend-monorepo/pull/1457/files#r2354334350
   */

  return imageUrl ? (
    <Box
      alignContent='center'
      bg='black'
      height={IMAGE_HEIGHT}
      justifyItems='center'
      position='relative'
      width={IMAGE_WIDTH}
    >
      <Box
        alignContent='center'
        height={height}
        justifyItems='center'
        position='relative'
        width={width}
      >
        <Image
          data-testid='tailgateGridModal_cameraFrame_image'
          h={height}
          src={imageUrl}
          w={width}
        />
        <TailgateGrid height={height} width={width} />
      </Box>
    </Box>
  ) : (
    <Box
      bgColor='black'
      borderRadius='0.375rem'
      data-testid='tailgateGridModal_cameraFrame_error'
      h='524px'
      maxW='100%'
      minW='577px'
    >
      <Center height='100%'>
        <Text color='white'>Cannot load camera image</Text>
      </Center>
    </Box>
  )
}
